import { useCallback } from 'react'
import { useStatusOverlay } from '@fs/zion-ui'
import { useGroupDataForm } from '../../../../hooks'
import transl from '../../ChangeHistory.transl'

export default function useRestore({ onFinish, setLoading, restoreData }) {
  const { saveGroupData } = useGroupDataForm()
  const showStatusOverlay = useStatusOverlay()
  const restore = useCallback(async () => {
    setLoading(true)

    try {
      const result = await saveGroupData(restoreData, true)
      showStatusOverlay({
        message: result.success ? transl.successRestoreMessage() : transl.failureRestoreMessage(),
        type: result.success ? 'success' : 'warning',
      })
      if (typeof onFinish === 'function') {
        onFinish()
      }
    } catch (e) {
      showStatusOverlay({ message: transl.errorRestoreMessage(), type: 'error' })
    }
    setLoading(false)
  }, [setLoading, saveGroupData, restoreData, showStatusOverlay, onFinish])

  return restore
}
